import { render, staticRenderFns } from "./government.vue?vue&type=template&id=7b6eb9b0&scoped=true&"
import script from "./government.vue?vue&type=script&lang=js&"
export * from "./government.vue?vue&type=script&lang=js&"
import style0 from "./government.vue?vue&type=style&index=0&id=7b6eb9b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6eb9b0",
  null
  
)

export default component.exports